import { MAIN_TWO_BLOCKS_CONTENT } from '@lib/flags';
import style from './AnimatedText.module.scss';

const splitTitle = (title, id) => {
  if (!title || !title[0]) return null;

  const str = title[0];

  if (id === 'text_2') {
    return [
      str.slice(0, 15), // "Квартал бизнес-"
      str.slice(15, 21), // "класса"
      str.slice(22, 33), // "в окружении"
      str.slice(34), // "парков"
    ];
  }
  if (id === 'text_1_mob') {
    return [
      str.slice(0, 7), // "Квартал"
      str.slice(8, 21), // "бизнес-класса"
      str.slice(22, 33), // "в окружении"
      str.slice(34), // "парков"
    ];
  }
  return [str];
};

const AnimatedText = ({ id, title }) => {
  const classMap = {
    text_2: [style.textStyle_one, style.textStyle_one_two, style.textStyle_two, style.textStyle_three],
    text_1_mob: [style.textStyleMob_one, style.textStyleMob_two, style.textStyleMob_three, style.textStyleMob_four],
  };

  const useOldLogic = !MAIN_TWO_BLOCKS_CONTENT || !title || !Array.isArray(title) || title.length === 0 || !title[0];

  if (useOldLogic) {
    switch (id) {
      case 'text_2':
        return (
          <div className={style.textBox}>
            <div className={style.textStyle_one}>Квартал бизнес-</div>
            <div className={style.textStyle_one_two}>класса</div>
            <div className={style.textStyle_two}>в окружении</div>
            <div className={style.textStyle_three}>парков</div>
          </div>
        );
      case 'text_1_mob':
        return (
          <div className={style.textBox}>
            <div className={style.textStyleMob_one}>Квартал</div>
            <div className={style.textStyleMob_two}>бизнес-класса</div>
            <div className={style.textStyleMob_three}>в окружении</div>
            <div className={style.textStyleMob_four}>парков</div>
          </div>
        );
      default:
        return null;
    }
  }

  const textArray = splitTitle(title, id);
  const classes = classMap[id] || [];

  return (
    <div className={style.textBox}>
      {textArray.map((text, i) => (
        <div className={classes[i] || ''} key={text}>
          {text}
        </div>
      ))}
    </div>
  );
};

export default AnimatedText;
